module.exports = __webpack_public_path__ + "media/npc_dota_hero_largo.d7d3baff.webm";